import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-1">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-2">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-3" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.2
      }} className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[85vh]" data-id="element-4">
            <div className="flex items-center justify-between p-6 border-b border-gray-100 flex-shrink-0" data-id="element-5">
              <h3 className="text-xl font-bold text-navy font-serif" data-id="element-6">
                {title}
              </h3>
              <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-7">
                <X className="w-5 h-5 text-gray-500" data-id="element-8" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto text-gray-600 text-sm leading-relaxed" data-id="element-9">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="bg-navy text-gray-400 py-12 px-4 border-t border-white/10" data-id="element-10">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center" data-id="element-11">
          <div className="mb-4 md:mb-0" data-id="element-12">
            <p className="font-serif text-lg text-cream" data-id="element-13">
              Kit Dormí de Nuevo (40+)
            </p>
            <p className="text-sm mt-1" data-id="element-14">
              © {new Date().getFullYear()} Todos los derechos reservados.
            </p>
          </div>

          <div className="flex space-x-6 text-sm" data-id="element-15">
            <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors" data-id="element-16">
              Términos
            </button>
            <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors" data-id="element-17">
              Privacidad
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-18">
        <div className="space-y-4" data-id="element-19">
          <p data-id="element-20">
            <strong data-id="element-21">1. Aceptación de los Términos</strong>
          </p>
          <p data-id="element-22">
            Al acceder y utilizar este sitio web y adquirir el Kit "Dormí de
            Nuevo (40+)", aceptás estos términos y condiciones en su totalidad.
          </p>

          <p data-id="element-23">
            <strong data-id="element-24">2. Descripción del Producto</strong>
          </p>
          <p data-id="element-25">
            El Kit "Dormí de Nuevo (40+)" es un producto digital (PDF) que
            contiene información educativa sobre técnicas y estrategias para
            mejorar la calidad del sueño. No constituye asesoramiento médico
            profesional.
          </p>

          <p data-id="element-26">
            <strong data-id="element-27">3. Uso del Producto</strong>
          </p>
          <p data-id="element-28">
            El contenido del kit es para uso personal y no puede ser
            redistribuido, copiado o compartido sin autorización expresa.
          </p>

          <p data-id="element-29">
            <strong data-id="element-30">4. Limitación de Responsabilidad</strong>
          </p>
          <p data-id="element-31">
            Este producto no reemplaza el consejo médico profesional. Si tenés
            problemas de salud o trastornos del sueño graves, consultá con un
            profesional de la salud.
          </p>

          <p data-id="element-32">
            <strong data-id="element-33">5. Política de Reembolso</strong>
          </p>
          <p data-id="element-34">
            Ofrecemos una garantía de satisfacción de 30 días. Si no estás
            conforme con el producto, podés solicitar un reembolso completo
            dentro de ese período.
          </p>

          <p data-id="element-35">
            <strong data-id="element-36">6. Modificaciones</strong>
          </p>
          <p data-id="element-37">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios serán efectivos inmediatamente después de su
            publicación.
          </p>
        </div>
      </Modal>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-38">
        <div className="space-y-4" data-id="element-39">
          <p data-id="element-40">
            <strong data-id="element-41">1. Información que Recopilamos</strong>
          </p>
          <p data-id="element-42">
            Recopilamos información personal que nos proporcionás
            voluntariamente al realizar una compra, como tu nombre y dirección
            de correo electrónico.
          </p>

          <p data-id="element-43">
            <strong data-id="element-44">2. Uso de la Información</strong>
          </p>
          <p data-id="element-45">Utilizamos tu información para:</p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-46">
            <li data-id="element-47">Procesar tu compra y entregar el producto digital</li>
            <li data-id="element-48">Enviarte comunicaciones relacionadas con tu compra</li>
            <li data-id="element-49">Mejorar nuestros productos y servicios</li>
          </ul>

          <p data-id="element-50">
            <strong data-id="element-51">3. Protección de Datos</strong>
          </p>
          <p data-id="element-52">
            Implementamos medidas de seguridad para proteger tu información
            personal contra acceso no autorizado, alteración o destrucción.
          </p>

          <p data-id="element-53">
            <strong data-id="element-54">4. No Compartimos tu Información</strong>
          </p>
          <p data-id="element-55">
            No vendemos, intercambiamos ni transferimos tu información personal
            a terceros, excepto cuando sea necesario para procesar tu pago.
          </p>

          <p data-id="element-56">
            <strong data-id="element-57">5. Cookies</strong>
          </p>
          <p data-id="element-58">
            Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
            navegación y analizar el tráfico del sitio.
          </p>

          <p data-id="element-59">
            <strong data-id="element-60">6. Tus Derechos</strong>
          </p>
          <p data-id="element-61">
            Tenés derecho a acceder, rectificar o eliminar tu información
            personal en cualquier momento.
          </p>

          <p data-id="element-62">
            <strong data-id="element-63">7. Cambios en esta Política</strong>
          </p>
          <p data-id="element-64">
            Podemos actualizar esta política de privacidad ocasionalmente. Te
            notificaremos sobre cambios significativos.
          </p>
        </div>
      </Modal>
    </>;
}